import SvgIcon, { SvgIconProps } from '../components/SvgIcon';

export interface Props extends SvgIconProps {}

const RestrictedIcon = ({ ...props }: Props) => {
  return (
    <SvgIcon
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_543_1770)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32 16.5C32 25.3366 24.8366 32.5 16 32.5C7.16344 32.5 0 25.3366 0 16.5C0 7.66344 7.16344 0.5 16 0.5C24.8366 0.5 32 7.66344 32 16.5ZM29 16.5C29 23.6797 23.1797 29.5 16 29.5C12.9818 29.5 10.2037 28.4714 7.99739 26.7456L26.2456 8.49739C27.9714 10.7037 29 13.4818 29 16.5ZM24.1384 6.36201C21.9107 4.57145 19.0805 3.5 16 3.5C8.8203 3.5 3 9.3203 3 16.5C3 19.5805 4.07145 22.4107 5.86201 24.6384L24.1384 6.36201Z"
          fill="#FA0707"
        />
      </g>
      <defs>
        <clipPath id="clip0_543_1770">
          <rect width="32" height="32" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default RestrictedIcon;
